import { render } from "./PurchasingRequisition.vue?vue&type=template&id=15562d52&scoped=true"
import script from "./PurchasingRequisition.vue?vue&type=script&lang=js"
export * from "./PurchasingRequisition.vue?vue&type=script&lang=js"

import "./PurchasingRequisition.vue?vue&type=style&index=0&id=15562d52&scoped=true&lang=css"
import "./PurchasingRequisition.vue?vue&type=style&index=1&id=15562d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15562d52"]])

export default __exports__